import { SETTINGS } from './../settings';

export default class Parallax { 
  parallaxNode;
  scrollPosition;
  constructor(parallaxNode) { 
    this.parallaxNode = parallaxNode;
  }

  setScrollPosition(scrollPosition) {
    this.scrollPosition = scrollPosition;
    let parallaxBreakpoints = this.getParallaxBreakpoints();
    if (parallaxBreakpoints) { 
      this.parallax(parallaxBreakpoints);
    }
  }

  getParallaxBreakpoints(){
    let parallaxBreakpointStart, parallaxBreakpointEnd;
    let elementOffsetTop = this.getOffsetTop(this.parallaxNode);
    parallaxBreakpointStart = elementOffsetTop - window.innerHeight;
    parallaxBreakpointEnd = elementOffsetTop + this.parallaxNode.clientHeight;
    if(this.scrollPosition > parallaxBreakpointStart && this.scrollPosition < parallaxBreakpointEnd){
      return {start: parallaxBreakpointStart, end: parallaxBreakpointEnd};
    }
    return null;
  }

  parallax(parallaxBreakpoints) { 
    let relScrollPosition = this.scrollPosition - parallaxBreakpoints.start;
    let relBreakpointEnd = parallaxBreakpoints.end - parallaxBreakpoints.start;
    let relPosition = (relScrollPosition * 100) / relBreakpointEnd;
    let speedX = this.parallaxNode.getAttribute('data-speed-x') ?
      parseInt(this.parallaxNode.getAttribute('data-speed-x')) :
      SETTINGS.PARALLAX.DEFAULT_SPEED;
    let speedY = this.parallaxNode.getAttribute('data-speed-y') ?
      parseInt(this.parallaxNode.getAttribute('data-speed-y')) :
      SETTINGS.PARALLAX.DEFAULT_SPEED;
    let tx = relPosition * speedX / 100;
    let ty = relPosition * speedY / 100;
    if (window.innerWidth < 768) {
      tx = 0;
      ty = 0;
    }
    this.parallaxNode.style.transform = 'translate(' + tx + 'px, ' + (ty * -1) +'px)';
  }

  getOffsetTop(element){
    var offsetTop = 0;
    do {
      offsetTop += element.offsetTop || 0;
      element = element.offsetParent;
    } while (element);
    return offsetTop;
  }

}


// WEBPACK FOOTER //
// ./ui/assets/js/ScrollAnimation/Parallax.js